import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { SEARCH_BEST_FOR_YOU_COOKIE } from 'constants/cookies';

import { CHECKOUT_URL_RE, CONFIRMATION_URL_RE } from 'common/regex';
import { triggerAssignment } from 'actions/ab';
import { setError } from 'actions/errors';
import Header from 'hf/Header';
import Footer from 'hf/Footer';
import CartModal from 'components/cart/CartModal';
import { componentDidCatchFullPageError } from 'common/componentHooks';
import ErrorPage from 'components/error/ErrorPage';
import LoginAssistant from 'components/LoginAssistant';
import NotificationsOverlay from 'components/NotificationsOverlay';
import PixelServer from 'containers/pixelserver/PixelServer';
import 'styles/global.scss';
import { ensureClass, ensureNoClass } from 'helpers';
import styles from 'styles/App.scss';
import { toggleNotificationsOverlay } from 'actions/notifications';
import marketplace from 'cfg/marketplace.json';
import { updateBestForYou } from 'actions/search';
import { setLastPageWasOrderconfirmation } from 'store/ducks/history/actions';

const { hasHf } = marketplace;

export class App extends Component {

  static fetchDataOnServer(store) {
    const { cookies } = store.getState();
    store.dispatch(updateBestForYou(!cookies[SEARCH_BEST_FOR_YOU_COOKIE] || cookies[SEARCH_BEST_FOR_YOU_COOKIE] !== 'active'));
  }

  componentDidUpdate(prevProps) {
    const { location: { pathname }, wasLastPageOrderConfirmation, setLastPageWasOrderconfirmation, isFacetsVisible: prevIsFacetsVisible, isFacetableView: prevIsFacetableView, error: prevError } = prevProps;
    const { isFacetsVisible, isFacetableView, error } = this.props;
    const resetLastPageOrderConfirmation = wasLastPageOrderConfirmation && !(CONFIRMATION_URL_RE.test(pathname) || CHECKOUT_URL_RE.test(pathname));

    if (resetLastPageOrderConfirmation) {
      setLastPageWasOrderconfirmation(false);
    }

    // When client routing related to search facets, maintain facet state (ie. keep facets open if needed).
    // Also ensures facet state is maintained while swapping between Wildcard/Search containers.
    if (isFacetsVisible !== prevIsFacetsVisible || isFacetableView !== prevIsFacetableView) {
      if (isFacetableView && isFacetsVisible) {
        ensureClass(document.body, styles.activeSidebar);
        ensureNoClass(document.body, 'activeMain');
      } else {
        ensureClass(document.body, 'activeMain');
        ensureNoClass(document.body, styles.activeSidebar);
      }
    }

    // Scroll to top on client-side error
    if (!prevError && error) {
      window.scrollTo(0, 0);
    }
  }

  componentDidCatch(error, info) {
    componentDidCatchFullPageError(this.props.setError, error, info);
  }

  makeChildren() {
    if (this.props.error) {
      return <ErrorPage error={this.props.error} />;
    } else {
      return React.Children.map(this.props.children, child => React.cloneElement(child, { setLayoutOption: this.setLayoutOption }));
    }
  }

  setLayoutOption = (option, value = true) => {
    const newState = {};
    newState[option] = value;
    this.setState(newState);
  }

  dismissOverlay = () => {
    this.props.toggleNotificationsOverlay();
  }

  render() {
    const { notifications: { showOverlay }, isModalShowing, isHfVisible } = this.props;
    const showHf = hasHf && isHfVisible;

    return (
      <div>
        { isModalShowing && <CartModal /> }
        {showHf && <Header />}
        <div key="main" className={styles.pageLayout}>
          <main id="main" className={styles.mainContent}>
            <div>
              {this.makeChildren()}
            </div>
          </main>
        </div>
        <PixelServer />
        {<NotificationsOverlay showOverlay={showOverlay} dismissOverlay={this.dismissOverlay} />}
        {showHf &&
          <>
            <LoginAssistant />
            <Footer />
          </>
        }
      </div>
    );
  }
}

App.contextTypes = {
  router: PropTypes.object.isRequired
};

App.propTypes = {
  // Injected by React Redux
  error: PropTypes.object,
  // Injected by React Router
  children: PropTypes.node
};

function mapStateToProps(state) {
  const {
    error,
    isFacetsVisible,
    isFacetableView,
    headerFooter: { isHfVisible },
    products,
    notifications,
    cart: { isModalShowing },
    routing: { locationBeforeTransitions: location },
    history: { wasLastPageOrderConfirmation },
    rewards
  } = state;

  return {
    error,
    isFacetsVisible,
    isFacetableView,
    isHfVisible,
    products,
    notifications,
    isModalShowing,
    location,
    rewards,
    wasLastPageOrderConfirmation
  };
}

export default connect(mapStateToProps, {
  setError,
  setLastPageWasOrderconfirmation,
  toggleNotificationsOverlay,
  triggerAssignment
})(App);
